import React from "react";
import ListeDePrix from "../components/ListeDePrix";

export default function Listedepirx() {
  return <ListeDePrix />;
}
